import React, { useState, useEffect  } from 'react'
import axios from 'axios';
import ScrollToTop from "react-scroll-to-top";
import { Container, Button, Link, lightColors, darkColors} from 'react-floating-action-button'
function Footer() {
const [posts, setPosts] = useState([]);
const [loading, setLoading] = useState(false);
let api = 'https://tallysolutions-uae.com/tallyprime/api/wp-json/wp/v2/contact_new?per_page=1';
useEffect(() => {
setLoading(true)
axios.get(api)
.then(res => {
//console.log(res)
setPosts(res.data)
setLoading(false)
})
}, [setPosts])
return (
<React.StrictMode>
   {
   loading && 
   <section className="bg-white pt-5"><img src="https://tallysolutions-uae.com/tallyprime//assets/img/loading.gif" alt="loading" className="mx-auto d-block mt-5 pt-5" width="20" /></section>
   }
   {!loading &&
   <>
   {posts.map((post,i) => (
   <span   dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
   ))}
   </>
   }
    <Container>
    <Link href="https://api.whatsapp.com/send?phone=+971563030344&amp;text=Hi, I just visited your website. I have some questions for you"
     target="_blank"
                tooltip="Whatsapp"
                icon="fa fa-whatsapp"
                styles={{backgroundColor: '#24CC63', color: '#fff'}} />
                
                <Link href="tel:+97165343120"
                tooltip="Call"
                icon="fa fa-phone"
                styles={{backgroundColor: '#3068B2', color: '#fff'}} />
           
            <Link href="mailto:info@wabcomdubai.com"
                tooltip="Email"
                icon="fa fa-envelope-open"
                styles={{backgroundColor: '#DA5046', color: '#fff'}} />
                
            <Button
                tooltip="Quick Contact"
                icon="fa fa-question"
                rotate={true}
                styles={{backgroundColor: darkColors.yellow, color: lightColors.white}}
                 />
        </Container>
    <ScrollToTop smooth />
</React.StrictMode>
)
}
export default Footer;










